module.exports = __webpack_public_path__ + "static/media/1029620.0627776b.jpg";